// extracted by mini-css-extract-plugin
export default {"dialog":"Dialog_dialog__91-oY","content":"Dialog_content__fC8ze","title":"Dialog_title__+aMqC","close":"Dialog_close__CwK9+"};